import Main from '@/layout/main.vue';

/**
 * meta: {
 *  hideInMenu: (false) 设为 true 后在左侧菜单不会显示该页面选项 （暂时没有）
 *  notCache: (false) 设为true后页面不会缓存
 *  noTag: (false) 设为true后不会添加到 navTag 中
 *  access: (null) 可访问该页面的权限数组，当前路由设置的权限会影响子路由
 *  icon: (-) 该页面在左侧菜单、面包屑和标签导航处显示的图标，如果是自定义图标，需要在图标名称前加下划线'_' (为引入)
 *  hideInBreadCrumb: (false) 设为 true 面包屑不会显示该页面选项
 *  select: (string) children组件选中父菜单的name
 * }
 */
const routes = [
  {
    path: '/',
    name: 'Home',
    component: Main,
    meta: {
      hideInMenu: true,
      hideInBreadCrumb: true,
    },
    children: [
      {
        path: '/home',
        meta: {
          title: '首页',
          hideInMenu: true,
          hideInBreadCrumb: true,
        },
        name: 'home',
        component: () => import('@/views/home.vue'),
      },
    ],
  },
  {
    path: '/account',
    name: 'account',
    component: Main,
    meta: {
      title: '账户',
      icon: '',
      showAlways: true,
    },
    children: [
      {
        path: '/about-list',
        name: 'aboutList',
        meta: {
          title: '账户列表',
        },
        component: () => import('@/views/account.vue'),
      },
    ],
  },
  {
    path: '/page-one',
    name: 'pageOne',
    component: Main,
    meta: {
      title: '页面一',
      icon: '1',
      showAlways: true,
    },
    children: [
      {
        path: '/page-one-content',
        name: 'pageOneContent',
        meta: {
          title: '页面一内容',
        },
        component: () => import('@/views/page-one.vue'),
      },
    ],
  },
  {
    path: '/page-two',
    name: 'pageTwo',
    component: Main,
    meta: {
      title: '页面二',
      icon: '1',
      showAlways: true,
    },
    children: [
      {
        path: '/page-two-content',
        name: 'pageTwoContent',
        meta: {
          title: '页面二内容',
        },
        component: () => import('@/views/page-two.vue'),
      },
    ],
  },
  {
    path: '/page-three',
    name: 'pageThree',
    component: Main,
    meta: {
      title: '页面三',
      icon: '1',
      showAlways: true,
    },
    children: [
      {
        path: '/page-three-content',
        name: 'pageThreeContent',
        meta: {
          title: '页面三内容',
        },
        component: () => import('@/views/page-three.vue'),
      },
    ],
  },
  {
    path: '/page-four',
    name: 'pageFour',
    component: Main,
    meta: {
      title: '页面四',
      icon: '1',
      showAlways: true,
    },
    children: [
      {
        path: '/page-four-content',
        name: 'pageFourContent',
        meta: {
          title: '页面四内容',
        },
        component: () => import('@/views/page-four.vue'),
      },
    ],
  },
  {
    path: '/page-five',
    name: 'pageFive',
    component: Main,
    meta: {
      title: '页面五',
      icon: '1',
      showAlways: true,
    },
    children: [
      {
        path: '/page-five-content',
        name: 'pageFiveContent',
        meta: {
          title: '页面五内容',
        },
        component: () => import('@/views/page-five.vue'),
      },
    ],
  },
  {
    path: '/page-six',
    name: 'pageSix',
    component: Main,
    meta: {
      title: '页面六',
      icon: '6',
      showAlways: true,
    },
    children: [
      {
        path: '/page-six-content',
        name: 'pageSixContent',
        meta: {
          title: '页面六内容',
        },
        component: () => import('@/views/page-six.vue'),
      },
    ],
  },
];

export default routes;
